import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="33" viewBox="0 0 66 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 0H0V33H66V0Z" fill="#00732F" />
    <path d="M66 11H0V33H66V11Z" fill="white" />
    <path d="M66 22H0V33H66V22Z" fill="black" />
    <path d="M16.5 0H0V33H16.5V0Z" fill="#FF0000" />
    <path d="M0 33V-1.03114e-06H66V33H0ZM0.825 32.3125H65.175V0.687498H0.825V32.3125Z" fill="#9F9D9D" />
  </svg>
)
